import React from 'react';
import { useThemeMode } from '../theme';
import { Switch } from './ui/Switch';

/** Mörkt-reglaget (40×22, knopp 16px) — växlar tema globalt, sparas i localStorage via ThemeCtx. */
export function ThemeSwitch({ label = true, color }: { label?: boolean; color?: string }) {
  const { mode, toggle } = useThemeMode();
  return (
    <Switch checked={mode === 'dark'} onChange={toggle} label={label ? 'Mörkt' : undefined} ariaLabel="Mörkt läge" color={color} />
  );
}
